import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'

import { Home } from './pages/Home';
import { AboutMyRvos } from './pages/AboutMyRvos';
import { AboutOurCompanies } from './pages/AboutOurCompanies';
import { AboutHistory } from './pages/AboutHistory';
import { AboutNewsletter } from './pages/AboutNewsletter';
import { Claims } from './pages/Claims';
import { InfoCenter } from './pages/InfoCenter'

import { Products } from './pages/Products';

import { Header } from './components/Header';
import { Footer } from './components/Footer';
import ScrollToTop from './components/ScrollToTop.js'

import { ProductsConfig } from './config';

import './App.scss'
import MakePayment from "./components/Payment/PaymentSteps";
import FindAnAgent from "./pages/FindAnAgent";
import AgentDetails from "./pages/AgentDetails";
import ContactUs from "./pages/ContactUs";
import Careers from "./pages/Careers";
import JobInfo from "./pages/JobInfo";
import {PrivacyPolicy} from "./pages/PrivacyPolicy";
import {TermsOfUse} from "./pages/TermsOfUse";
import PortalSelection from "./pages/PortalSelection";
import HelpMeDecide from "./pages/HelpMeDecide";
import PortalRedirect from "./pages/PortalRedirect";


import {useSelector} from "react-redux";

function App() {
  const agentsStore = useSelector((store) => store.agentsStore);
  const careersStore = useSelector((store) => store.careersStore);
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      <Routes >
        <Route path="/" element={<Home />} />
        <Route path="/about/my-rvos" element={<AboutMyRvos />} />
        <Route path="/about/our-companies" element={<AboutOurCompanies />} />
        <Route path="/about/history" element={<AboutHistory />} />
        <Route path="/about/newsletter" element={<AboutNewsletter />} />

        <Route path="products/farm_and_ranch" element={<Products productData={ProductsConfig.farmAndRanch} />} />
        <Route path="products/manufactured_and_mobile_home" element={<Products productData={ProductsConfig.manufactured} />} />
        <Route path="products/home_owners" element={<Products productData={ProductsConfig.homeOwners} />} />
        <Route path="products/landlord" element={<Products productData={ProductsConfig.landlord} />} />
        <Route path="products/organization" element={<Products productData={ProductsConfig.organization} />} />
        <Route path="products/commercial" element={<Navigate to="/" replace />} />

        <Route path="/claims" element={<Claims />} />
        <Route path="/info-center" element={<InfoCenter />} />
        <Route path="/payment" element={<MakePayment />} />
        <Route path="/find-an-agent" element={<FindAnAgent />} />
        <Route path={`/agent/:id`} element={<AgentDetails />} />
        <Route path="/contact-us" element={<ContactUs />} />

        <Route path="/careers" element={<Careers />} />
        <Route path={`/careers/:id`} element={<JobInfo />} />

        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />

        <Route path="/portal-selection" element={<PortalSelection />} />
        <Route path="/help-me-decide" element={<HelpMeDecide />} />
        <Route path="/portal-redirect" element={<PortalRedirect />} />
      </Routes >
      <Footer />
    </BrowserRouter>
  );
}

export default App;


